import { Button } from 'components/shadcn/button';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-8">
        <div className="relative">
          <div className="text-9xl font-bold text-primary opacity-20">404</div>
        </div>

        <div className="space-y-4">
          <h1 className="text-3xl font-bold text-gray-800 text-balance">
            {t('errors.pageNotFound')}
          </h1>
          <p className="text-muted-foreground text-lg text-pretty">
            {t('errors.pageNotFoundSubtitle')}
          </p>
          <p className="text-sm text-muted-foreground text-pretty">
            {t('errors.pageNotFoundDescription')}
          </p>
        </div>

        <div className="space-y-3">
          <Button onClick={() => navigate(-1)} variant="outline" size="lg" className="w-full">
            {t('common.goBack')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
